// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd11b0c2","239":"37601dd7","453":"8b7f227e","455":"d7999b03"}[chunkId] + ".chunk.js";
};